<template>
  <span class="zm-radio" :class="{'zm-radio--large': size === 'large'}">
    <span class="zm-radio__wrap">
      <input
        class="zm-radio__original"
        :value="label"
        type="radio"
        v-model="model"
        @focus="focus = true"
        @blur="focus = false"
        @change="handleChange"
        :id="uid"
        :name="radioName"
        :disabled="isDisabled"
        :aria-checked="(model===label).toString()"
        :tabIndex="tabIndex"
        :aria-describedby="describedId"
        :aria-labelledby="labelledbyId"
      >
      <label
        class="zm-radio__label"
        :class="[
          { 'is-disabled': isDisabled },
          { 'is-focus': focus },
          { 'is-checked': model === label }
        ]"
        :for="uid"
      >
        <span class="zm-radio__inner"></span>
        <span
          class="zm-radio__label--inner"
          :id="labelledbyId"
          :aria-hidden="true"
        >
          <slot></slot>
          <template v-if="!$slots.default">{{label}}</template>
        </span>
      </label>
      <span class="zm-radio__suffix" v-if="$slots.suffix">
        <slot name="suffix"></slot>
      </span>
    </span>
    <slot v-if="$slots.child" name="child"></slot>
  </span>
</template>
<script>
  import Emitter from '../../mixins/emitter';

  let _uid = 0;

  function uid() {
    return _uid++;
  }

  export default {
    name: 'ZmRadio',

    mixins: [Emitter],

    inject: {
      ZmForm: {
        default: ''
      },

      ZmFormItem: {
        default: ''
      }
    },

    componentName: 'ZmRadio',

    props: {
      value: [String, Number, Boolean, Array],
      label: [String, Number, Boolean, Array],
      disabled: Boolean,
      name: String
    },

    data() {
      return {
        focus: false,
        isGroup: false
      };
    },

    computed: {
      model: {
        get() {
          return this.isGroup ? this._radioGroup.value : this.value;
        },
        set(val) {
          if (this.isGroup) {
            this.dispatch('ZmRadioGroup', 'input', [val]);
          } else {
            this.$emit('input', val);
          }
        }
      },
      isDisabled() {
        return this.isGroup
          ? this._radioGroup.disabled || this.disabled || (this.ZmForm || {}).disabled
          : this.disabled || (this.ZmForm || {}).disabled;
      },
      tabIndex() {
        return !this.isDisabled ? (this.isGroup ? (this.model === this.label ? 0 : -1) : 0) : -1;
      },
      radioName() {
        return this.isGroup ? (this._radioGroup.name || this.name) : this.name;
      },
      describedId() {
        if (this._radioGroup && this._radioGroup.enterSelect && this.model !== this.label) {
          return this._radioGroup.uid;
        }
        return null;
      },
      labelledbyId() {
        return this.uid + '-labelledby';
      },
      uid() {
        return (this.isGroup ? this._radioGroup.uid + '-radio-' : 'zm-radio-') + uid();
      },
      _elFormItemSize() {
        return (this.ZmFormItem || {}).elFormItemSize;
      },
      size() {
        return this._elFormItemSize || (this.$ELEMENT || {}).size;
      }
    },

    watch: {
      isDisabled() {
        this.isGroup && this.dispatch('ZmRadioGroup', 'updateRadioUseStatus');
      }
    },

    created() {
      this.isGroup = false;
      let parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== 'ZmRadioGroup') {
          parent = parent.$parent;
        } else {
          this.isGroup = true;
          this._radioGroup = parent;
          break;
        }
      }
    },

    methods: {
      handleChange() {
        this.$nextTick(() => {
          this.$emit('change', this.model);
          this.isGroup && this.dispatch('ZmRadioGroup', 'handleChange', this.model);
        });
      }
    }
  };
</script>

<style lang="scss">
  @import "./style";
</style>
